import { render, staticRenderFns } from "./LKRoadmapsFeedLayout.vue?vue&type=template&id=6f4c88d7&"
import script from "./LKRoadmapsFeedLayout.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedLayout.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/transitions/transition-fade.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports